import { useState } from 'react';

import { ReactComponent as ChevronIcon } from '@rikstv/play-common/src/icons/svg/chevron-light.svg';
import { Link } from '@rikstv/play-common/src/router/Link';
import { commonRouterPaths } from '@rikstv/play-common/src/router/router.path';
import { linearCoverpageFunnel } from '@rikstv/play-common/src/utils/analytics/posthogProvider';
import { H3, SecondaryButton } from '@rikstv/shared-components';

import { useTvGuideChannels } from '../../tvGuide-v2/useTvGuideChannels';

import { ChannelOverview } from './ChannelOverview';

import styles from './ChannelGrid.module.css';

export const ChannelGrid = () => {
  const [maxPrograms, setMaxPrograms] = useState(10);
  const { channels } = useTvGuideChannels({ includePrograms: false });

  const showMoreChannels = () => setMaxPrograms(channels?.length || 10);

  if (!channels) {
    return null;
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.titleWrapper}>
        <H3 style={{ margin: 0 }}>Kanalliste</H3>
        <TVGuideLink />
      </div>
      <div className={styles.channelGrid}>
        {channels.slice(0, maxPrograms).map((channel, idx) => (
          <ChannelOverview
            onClick={() => linearCoverpageFunnel.captureClickChannelFromChannelGrid(channel.channelId, idx)}
            key={`channel-overview-${channel.channelId}`}
            channel={channel}
            nrOfProgramsToShow={3}
          />
        ))}
      </div>
      {channels.length > maxPrograms && (
        <SecondaryButton style={{ marginTop: 'var(--rds-spacing--16' }} onClick={showMoreChannels}>
          Vis alle kaneler
        </SecondaryButton>
      )}
    </div>
  );
};

const TVGuideLink = () => {
  return (
    <Link to={commonRouterPaths.tvGuide} className={styles.tvGuideLink}>
      Til hele TV-guiden
      <ChevronIcon className={styles.chevron} height="24px" width="30px" aria-hidden="true" />
    </Link>
  );
};
